module.exports = __webpack_public_path__ + "static/img/SarahJones.1c06d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SarahJones.jpg
// module id = vJMk
// module chunks = 0